import { Text } from "rizzui/typography";
import CloseModal from "./closeModalIcon";

export default function UpdateMapping({ properties }: { properties: Object }) {
  console.log(properties);
  return (
    <div className="border-[.5px] border-muted bg-background dark:bg-[#2A2C30] rounded-[8px] max-w-[497px] max-h-[calc(100%-50px)] p-[32px]">
      <CloseModal />
      <div className="flex flex-col gap-[8px]">
        <Text className="font-ibmPlexSerif text-[18px] text-primary-dark font-[600]">
          Update data mapping
        </Text>
        <Text className="max-w-[379px] font-switzer text-[14px] text-[#758599]">
          Update your CRM fields to RingConnect fields to ensure data syncs
          correctly
        </Text>
      </div>

      <div className="mt-[30px]"></div>
    </div>
  );
}
